import React, { useState, useEffect, useRef } from "react";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { filtrarLeads, listarLeads } from "../../../actions/leadsActions";
import useSelectAsesores from "../../../hooks/useSelectAsesores";
import useSelectProyecto from "../../../hooks/useSelectProyectos";
import useSelectEstadosLeads from "../../../hooks/useSelectEstadosLeads";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire } from "@fortawesome/free-solid-svg-icons";
import useSelectFuenteMulti from "../../../hooks/useSelectFuenteMulti";
import useSelectMedioContacto from "../../../hooks/useSelectMedioContacto";


const FormularioFiltro = ({ contacto = false, soloCalientes = false, setSoloCalientes = () => {}, totalCalientes = 0 }) => {
    const dispatch = useDispatch();
    const { usuario } = useSelector((state) => state.usuario);
    const { filtrado } = useSelector((state) => state.leads);
    const [filters, setFilters] = useState({});
    const [asesor, SelectAsesor, setAsesor] = useSelectAsesores(null);
    const [proyecto, SelectProyecto, setProyecto] = useSelectProyecto(null);
    const [estado, SelectEstado, setEstado] = useSelectEstadosLeads(null);
    const [fechaFiltro, setFechaFiltro] = useState(null);
    const [fechaFiltroHasta, setFechaFiltroHasta] = useState(null);
    const [fuente, SelectFuente, setFuente] = useSelectFuenteMulti(null);
    const [medio, SelectMedio, setMedio] = useSelectMedioContacto(null);
    const [checkOmitir, setCheckOmitir] = useState(false);
    const isInitialized = useRef(false);

    const handleFiltroChange = (key, value) => {
        const newFilter = { ...filters, [key]: value };
        setFilters(newFilter);
        localStorage.setItem('filters', JSON.stringify(newFilter));
    };

    // Restaurar filtros guardados al montar
    // La carga inicial la hace ListaLeads — aquí solo restauramos el estado visual
    useEffect(() => {
        const savedFilters = localStorage.getItem('filters');
        if (savedFilters) {
            const p = JSON.parse(savedFilters);
            if (p.fechaFiltro && p.fechaFiltroHasta) {
                setFilters(p);
                setAsesor(p.asesor);
                setProyecto(p.proyecto);
                setEstado(p.estado);
                setFechaFiltro(new Date(p.fechaFiltro));
                setFechaFiltroHasta(new Date(p.fechaFiltroHasta));
                setFuente(p.fuente);
                setMedio(p.medio);
                setCheckOmitir(p.checkOmitir);
            } else {
                // Filtros guardados sin fechas → mostrar mes actual
                setFechaFiltro(moment().startOf('month').toDate());
                setFechaFiltroHasta(new Date());
            }
        } else {
            // Sin filtros → mostrar mes actual
            setFechaFiltro(moment().startOf('month').toDate());
            setFechaFiltroHasta(new Date());
        }
        // Marcar como inicializado después de que React procese todos los setState
        const t = setTimeout(() => { isInitialized.current = true; }, 0);
        return () => clearTimeout(t);
    }, []);

    // Búsqueda dinámica: solo para cambios del usuario (no en carga inicial)
    useEffect(() => {
        if (!isInitialized.current) return;
        if (!fechaFiltro || !fechaFiltroHasta) return;
        const timer = setTimeout(() => {
            const datosFiltro = {
                asesor: asesor ? asesor : null,
                fechaFiltroDesde: moment(fechaFiltro).format("YYYY-MM-DD"),
                fechaFiltroHasta: moment(fechaFiltroHasta).format("YYYY-MM-DD"),
                proyecto: proyecto ? proyecto : null,
                estado: estado ? estado : null,
                fuente: fuente !== "" ? fuente : null,
                medio_contacto: medio ? medio.id : null,
                checkOmitir: checkOmitir,
            };
            dispatch(filtrarLeads(datosFiltro, usuario, contacto));
        }, 600);
        return () => clearTimeout(timer);
    }, [asesor, proyecto, estado, fuente, medio, fechaFiltro, fechaFiltroHasta, checkOmitir]);
    const handleUrlDescargaDialFire = () => {
        const estados_str = estado
            ? estado
                .map((est, i) => {
                    return est.id_estado;
                })
                .join(",")
            : "";
        return `${process.env.REACT_APP_API_URL}/admin/csv/export/DialFire/${
            asesor ? asesor.id_usuario : null
        }/${proyecto ? proyecto.id_proyecto : null}/${
            fechaFiltro ? moment(fechaFiltro).format("YYYY-MM-DD") : null
        }/${
            fechaFiltroHasta
                ? moment(fechaFiltroHasta).format("YYYY-MM-DD")
                : null
        }/${estados_str}/${checkOmitir ? "1" : "0"}`;
    };

    const limpiarFiltros = () => {
        setAsesor(null);
        setProyecto(null);
        setEstado(null);
        setFechaFiltro(null);
        setFechaFiltroHasta(null);
        setFuente(null);
        setMedio(null);
        setCheckOmitir(false);
        setFilters({});
        localStorage.removeItem('filters');
        dispatch(listarLeads(usuario, contacto));
    };

    const handleAplicar = () => {
        if (!fechaFiltro || !fechaFiltroHasta) return;
        const datosFiltro = {
            asesor: asesor ? asesor : null,
            fechaFiltroDesde: moment(fechaFiltro).format("YYYY-MM-DD"),
            fechaFiltroHasta: moment(fechaFiltroHasta).format("YYYY-MM-DD"),
            proyecto: proyecto ? proyecto : null,
            estado: estado ? estado : null,
            fuente: fuente !== "" ? fuente : null,
            medio_contacto: medio ? medio.id : null,
            checkOmitir: checkOmitir,
        };
        dispatch(filtrarLeads(datosFiltro, usuario, contacto));
    };


    return (
        <div className="card mb-2" style={{ border: '1px solid #dee2e6' }}>
            <div className="card-body p-2">
                        {/* Fila 1: quién / qué */}
                <div className="row align-items-end mx-n1 mb-1">
                    <div className="col-md-3 px-1">
                        <label className="small font-weight-bold mb-1">Asesor</label>
                        <SelectAsesor
                            value={asesor}
                            onChange={(value) => { setAsesor(value); handleFiltroChange('asesor', value); }}
                        />
                    </div>
                    <div className="col-md-3 px-1">
                        <label className="small font-weight-bold mb-1">Producto</label>
                        <SelectProyecto
                            value={proyecto}
                            onChange={(value) => { setProyecto(value); handleFiltroChange('proyecto', value); }}
                        />
                    </div>
                    <div className="col-md-2 px-1">
                        <label className="small font-weight-bold mb-1">Estado</label>
                        <SelectEstado
                            value={estado}
                            onChange={(value) => { setEstado(value); handleFiltroChange('estado', value); }}
                        />
                    </div>
                    <div className="col-md-2 px-1">
                        <label className="small font-weight-bold mb-1">Fuente</label>
                        <SelectFuente
                            value={fuente}
                            onChange={(value) => { setFuente(value); handleFiltroChange('fuente', value); }}
                        />
                    </div>
                    <div className="col-md-2 px-1">
                        <label className="small font-weight-bold mb-1">Medio de contacto</label>
                        <SelectMedio
                            value={medio}
                            onChange={(value) => { setMedio(value); handleFiltroChange('medio', value); }}
                        />
                    </div>
                </div>
                {/* Fila 2: cuándo + acciones */}
                <div className="row align-items-end mx-n1">
                    <div className="col-md-2 px-1">
                        <label className="small font-weight-bold mb-1">Desde</label>
                        <DatePicker
                            selected={fechaFiltro}
                            onChange={(date) => { setFechaFiltro(date); handleFiltroChange('fechaFiltro', date); }}
                            selectsStart
                            dateFormat="dd/MM/yyyy"
                            autoComplete="off"
                            name="fechaFiltro"
                            startDate={fechaFiltro}
                            className="form-control form-control-sm"
                            endDate={fechaFiltroHasta}
                        />
                    </div>
                    <div className="col-md-2 px-1">
                        <label className="small font-weight-bold mb-1">Hasta</label>
                        <DatePicker
                            selected={fechaFiltroHasta}
                            onChange={(date) => { setFechaFiltroHasta(date); handleFiltroChange('fechaFiltroHasta', date); }}
                            selectsStart
                            dateFormat="dd/MM/yyyy"
                            className="form-control form-control-sm"
                            name="fechaFiltroHasta"
                            startDate={fechaFiltro}
                            endDate={fechaFiltroHasta}
                            minDate={fechaFiltro}
                            autoComplete="off"
                        />
                    </div>
                    <div className="col-md-4 px-1 d-flex align-items-end">
                        <div className="form-check mb-0 mr-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="check-omitir"
                                checked={checkOmitir}
                                onChange={() => { setCheckOmitir(!checkOmitir); handleFiltroChange('checkOmitir', !checkOmitir); }}
                            />
                            <label className="form-check-label small" htmlFor="check-omitir">
                                Omitir exportados anteriormente
                            </label>
                        </div>
                    </div>
                    <div className="col-md-4 px-1 d-flex align-items-end justify-content-end" style={{ gap: '6px' }}>
                        {!contacto && filtrado.length > 0 && asesor && proyecto && fechaFiltro && fechaFiltroHasta && estado && (
                            <Button href={handleUrlDescargaDialFire()} variant="outline-info" size="sm">
                                <i className="fas fa-download mr-1"></i>CSV DialFire
                            </Button>
                        )}
                        <button
                            type="button"
                            className="btn btn-sm"
                            onClick={() => setSoloCalientes(!soloCalientes)}
                            style={{
                                backgroundColor: soloCalientes ? '#fd7e14' : '#fff',
                                color: soloCalientes ? '#fff' : '#fd7e14',
                                border: '1px solid #fd7e14',
                                fontWeight: 600,
                                boxShadow: soloCalientes ? '0 0 8px #fd7e1480' : 'none',
                                transition: 'all .15s ease-in-out',
                            }}
                            title={soloCalientes ? 'Mostrando solo leads calientes — clic para ver todos' : 'Filtrar solo leads calientes'}
                        >
                            <FontAwesomeIcon icon={faFire} className="mr-1" />
                            Calientes {`(${totalCalientes})`}
                        </button>
                        <button className="btn btn-sm btn-primary" onClick={handleAplicar}>
                            <i className="fas fa-search mr-1"></i>Aplicar filtros
                        </button>
                        <button className="btn btn-sm btn-outline-secondary" onClick={limpiarFiltros}>
                            <i className="fas fa-times mr-1"></i>Limpiar filtros
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormularioFiltro;
